import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function (__props) {
        var store = useStore();
        var route = useRoute();
        onMounted(function () {
            var _a, _b;
            if ((_a = route === null || route === void 0 ? void 0 : route.query) === null || _a === void 0 ? void 0 : _a.code) {
                var datas = (_b = route === null || route === void 0 ? void 0 : route.query) === null || _b === void 0 ? void 0 : _b.code;
                window.localStorage.setItem('token', datas);
            }
            if (localStorage.getItem('token')) {
                store.commit('setHistroyList');
                store.commit('setDrawHistroyList');
                store.commit('setSimpleList');
                store.dispatch('getUserInfo');
                store.dispatch('intelligence/getHistoryList');
                store.dispatch('intelligence/getAllList');
            }
        });
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
